import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Sandra',
    dogDetails: 'Hund: Balu, Labrador, 4 Jahre',
    text: 'Balu hat sich wochenlang ständig die Pfoten geleckt. Nach dem Topping hat sich das innerhalb von 10 Tagen komplett gelegt. Wir sind so erleichtert.',
    initials: 'S'
  }, {
    name: 'Melanie',
    dogDetails: 'Hund: Nala, Golden Retriever, 6 Jahre',
    text: 'Ich war skeptisch, aber nach 2 Wochen hatte Nala zum ersten Mal wieder entspannte Pfoten ohne Rötungen. Das Topping bleibt jetzt fester Bestandteil.',
    initials: 'M'
  }, {
    name: 'Thomas',
    dogDetails: 'Hund: Rocky, Französische Bulldogge, 3 Jahre',
    text: 'Viele Jahre viel Geld beim Tierarzt ausgegeben. Nichts hat dauerhaft geholfen. Um so überraschter war ich, als schon nach 3 Wochen deutliche Besserung eintrat.',
    initials: 'T'
  }];
  return <section className="w-full py-16 px-4 md:px-8 bg-offWhite border-y border-warmBrown/10" data-id="element-133">
      <div className="max-w-5xl mx-auto" data-id="element-134">
        <h2 className="font-handwritten text-4xl text-center text-forestGreen font-bold mb-12" data-id="element-135">
          Erfahrungen anderer Hundehalter
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-136">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-warmBrown/10 flex flex-col" data-id="element-137">
              <div className="flex items-center gap-3 mb-4" data-id="element-138">
                <div className="w-10 h-10 rounded-full bg-forestGreen/10 flex items-center justify-center text-forestGreen font-bold font-serif shrink-0" data-id="element-139">
                  {review.initials}
                </div>
                <div className="flex gap-1 text-amber-400" data-id="element-140">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-141" />)}
                </div>
              </div>

              <p className="font-serif text-gray-800 leading-relaxed mb-6 flex-grow" data-id="element-142">
                "{review.text}"
              </p>

              <div className="mt-auto" data-id="element-143">
                <p className="font-bold font-serif text-forestGreen text-sm" data-id="element-144">
                  {review.name}
                </p>
                <p className="text-warmBrown/80 text-xs font-serif mt-0.5" data-id="element-145">
                  ({review.dogDetails})
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}